const apiKey = process.env.REACT_APP_API_KEY;
const actionLevel = 0.004;

module.exports = { apiKey, actionLevel };